export default __webpack_public_path__ + "static/media/01-sea.6ef225f2.gif";